module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aster-plot-placeholder"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-36369f5b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dataVisualization/d3js/asterPlot.vue
// module id = 1718
// module chunks = 61